import store from '../store/store';
import { mutatorAction } from 'satcheljs';
import { PremiumLegacyTenantResponse } from '../contracts/premiumLegacyTenantResponse';

export default mutatorAction('setPremiumLegacyTenant', function setPremiumLegacyTenant(
    response: PremiumLegacyTenantResponse
) {
    if (response !== null) {
        store.legacyPremiumTenant = response;
    }
});
